import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Loader from './../../loader';
import { submitInstitutionForApproval, getRequirements } from '../../../reducers/tenants';
import { FormattedMessage } from 'react-intl';
import messages from '../../../text/messages';
import { getJobs } from '../../../reducers/jobs';

const withRequirements = Page =>
    class extends React.Component {
        static loading = false;
        static loadingJobs = false;

        constructor(props) {
            super(props);

            this.shouldLoadRequirements = this.shouldLoadRequirements.bind(this);
            this.shouldLoadJobs = this.shouldLoadJobs.bind(this);
            this.loadRequirements = this.loadRequirements.bind(this);
            this.loadJobs = this.loadJobs.bind(this);
        }

        shouldLoadRequirements(props) {
            let { role, details, requirements } = props;
            return role && details && !requirements;
        }

        shouldLoadJobs(props) {
            let { role, details, jobs } = props;
            return role && role.type === 'contractor' && details && !jobs;
        }

        loadRequirements(props, override) {
            let { role } = props;
            let { getRequirements } = this.props;

            let should = this.shouldLoadRequirements(props);

            if ((override && role) || (should && withRequirements.loading === false)) {
                withRequirements.loading = true;
                getRequirements(role, () => (withRequirements.loading = false));
            }
        }

        loadJobs(props) {
            let { role, getJobs } = props;

            let should = this.shouldLoadJobs(props);

            if (should) {
                getJobs(role);
            }
        }

        componentDidMount() {
            this.loadRequirements(this.props);
            this.loadJobs(this.props);
        }

        componentDidUpdate(prevProps) {
            let currentRole = prevProps.role ? prevProps.role.id : undefined;
            let newRole = this.props.role ? this.props.role.id : undefined;

            if (currentRole !== newRole) {
                this.loadRequirements(this.props, true);
                this.loadJobs(this.props);
            }
        }

        render() {
            const { requirements } = this.props;

            if (this.shouldLoadRequirements(this.props) && !requirements) {
                return <Loader showOverride={true} message={<FormattedMessage {...messages.loadingRequirements} />} />;
            }

            if (this.shouldLoadJobs(this.props)) {
                return <Loader showOverride={true} message={<FormattedMessage {...messages.loadingRequirements} />} />;
            }

            return <Page {...this.props} />;
        }
    };

const mapStateToProps = state => ({
    role: state.identity.role,
    details: state.identity.details,
    tenants: state.tenants,
    requirements: state.tenants ? state.tenants.requirements : undefined,
    jobs: state.jobs ? state.jobs.list : undefined
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            getRequirements: getRequirements,
            submitForApproval: submitInstitutionForApproval,
            getJobs: getJobs
        },
        dispatch
    );

export default compose(connect(mapStateToProps, mapDispatchToProps), withRequirements);



// WEBPACK FOOTER //
// ./src/components/hoc/requirements/index.jsx